import { type PrimitiveAtom, useAtom } from 'jotai'
import React from 'react'

// mapAtom の中の1エントリだけを useState のように読み書きする。
// key に対応する値が無ければ空文字を返す。
export const useKeyedAtomEntry = (
  mapAtom: PrimitiveAtom<Partial<Record<string, string>>>,
  key: string,
): [string, (next: string) => void] => {
  const [map, setMap] = useAtom(mapAtom)

  const setValue = React.useCallback(
    (next: string) => {
      setMap((prev) => ({ ...prev, [key]: next }))
    },
    [key, setMap],
  )

  return [map[key] ?? '', setValue]
}
